<template>
  <div>
    <div class="landing">
      <div class="mobile hidden-md hidden-lg hidden-xl">
        <div class="main">
          <div class="inna-logo text-center">
            <img src="../assets/Logo.svg" />
          </div>
          <form novalidate @submit.prevent="validateBeforeSubmit">
            <div
              v-for="(status, index) in statusList.filter(s => s.type === 'error' || s.type === 'warning' || s.type === 'info')"
              :key="index"
              :class="{
                'banner-error': status.type === 'error',
                'banner-warning': status.type === 'warning',
                'banner-info': status.type === 'info'
              }"
            >
              <div class="bannerText">
                <div>
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="status.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-error" v-if="errorText.length > 0">
              <div class="bannerText">
                <div v-for="(error, index) in errorText" :key="index">
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="error.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-warning" v-if="warningText.length > 0">
              <div class="bannerText">
                <div v-for="(warning, index) in warningText" :key="index">
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="warning.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-info" v-if="infoText.length > 0">
              <div class="bannerText">
                <div v-for="(info, index) in infoText" :key="index">
                  <i class="fa fa-info-circle" />
                  &nbsp;
                  <span v-html="info.text"></span>
                </div>
              </div>
            </div>

            <div class="login">
              <div class="splitter">
                <div class="split left"></div>
                <div class="split-text">SKRÁÐU ÞIG INN MEÐ:</div>
                <div class="split right"></div>
              </div>
              <button style="border-radius:5px;" class="btn btn-opacity-island" v-on:click.prevent="island()">
                <!-- <img src="../assets/Island.is.svg" /> -->
                <img src="../assets/island_is_RGB_Hvitt@2x.png" style="width: 150px" alt="Ísland.is" />
              </button>
              <!--button class="btn btn-opacity" v-on:click.prevent="google()"><img src="../assets/google.svg"></button-->
              <button v-if="googleEnabled" style="border-radius:5px;" type="button" class="btn btn-opacity-google" v-on:click.prevent="google()">
                <img src="../assets/btn_google_light_normal_ios.svg" rel="stylesheet" style="float:left;" />
                <span class="googleClass">Google</span>
              </button>
              <button v-if="o365Enabled" style="border-radius:5px;" type="button" class="btn btn-opacity-office" v-on:click.prevent="o365()">
                <img src="../assets/office.svg" alt="Office" />
              </button>
              <button style="border-radius:5px;" class="btn btn-opacity btn-pw" v-on:click.prevent="pw()">Lykilorð</button>
              <input
                type="text"
                class="form-control"
                v-if="showPassword"
                id="username"
                name="username"
                placeholder="Kennitala"
                v-model="username"
                v-validate="'required'"
              />
              <span class="help-block" v-if="errors.has('username:required')">Vinsamlegast sláðu inn kennitölu.</span>
              <input
                type="password"
                v-if="showPassword"
                class="form-control"
                id="password"
                name="password"
                placeholder="Lykilorð"
                v-model="password"
                v-validate="'required'"
              />
              <span class="help-block" v-if="errors.has('password:required')">Vinsamlegast sláðu inn lykilorð.</span>
              <button type="submit" v-if="showPassword" class="btn btn-login" @click.prevent="validateBeforeSubmit">Innskrá</button>
              <div class="text-center" v-if="showPassword"><a href="/gleymt-lykilord" style="color:#fff">Gleymt lykilorð?</a></div>

              <!-- <div class="splitter" style="margin-top: 30px;">
                <div class="split left"></div>
                <div class="split-text">MEÐ VEFPÓST SKÓLA:</div>
                <div class="split right"></div>
              </div>

              <button style="border-radius:5px;" type="button" class="btn btn-opacity-google" v-on:click.prevent="azure('KVSK')">
                <img src="../assets/kvennaskolinn.png" style="float:left; width: 30px; height: 30px; position: absolute; left: 10px; top: 7px;" />
                <div class="schoolClass">Kvennaskólinn</div>
              </button> -->
            </div>
          </form>
        </div>
      </div>
      <div class="desktop hidden-sm hidden-xs">
        <div class="main">
          <div class="top-row">
            <div class="inna-logo">
              <img src="../assets/Logo.svg" />
            </div>
            <div class="anchors pull-right">
              <div v-on:click="scrollTo('#kennslukerfi')">Kennslukerfi</div>
              <div v-on:click="scrollTo('#skólakerfi')">Skólakerfi</div>
              <div v-on:click="scrollTo('#nemendur')">Nemendur</div>
              <div v-on:click="scrollTo('#inna')">Um Innu</div>
              <div><a href="/privacypolicy" style="color:#fff;text-decoration:none">Persónuverndarstefna</a></div>
            </div>
          </div>
          <form novalidate @submit.prevent="validateBeforeSubmit">
            <div
              v-for="(status, index) in statusList.filter(s => s.type === 'error' || s.type === 'warning' || s.type === 'info')"
              :key="index"
              :class="{
                'banner-error': status.type === 'error',
                'banner-warning': status.type === 'warning',
                'banner-info': status.type === 'info'
              }"
            >
              <div class="bannerText">
                <div>
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="status.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-error" v-if="errorText.length > 0">
              <div class="bannerText">
                <div v-for="(error, index) in errorText" :key="index">
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="error.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-warning" v-if="warningText.length > 0">
              <div class="bannerText">
                <div v-for="(warning, index) in warningText" :key="index">
                  <i class="fa fa-exclamation-circle" />
                  &nbsp;
                  <span v-html="warning.text"></span>
                </div>
              </div>
            </div>
            <div class="banner-info" v-if="infoText.length > 0">
              <div class="bannerText">
                <div v-for="(info, index) in infoText" :key="index">
                  <i class="fa fa-info-circle" />
                  &nbsp;
                  <span v-html="info.text"></span>
                </div>
              </div>
            </div>

            <div class="slogan-and-login">
              <div class="slogan">
                Miðlum þekkingu saman
              </div>
              <div class="login">
                <div class="alert alert-danger" v-if="errorList.length > 0">
                  <ul class="list-unstyled">
                    <li v-for="(e, idx) in errorList" :key="idx">
                      {{ e }}
                    </li>
                  </ul>
                </div>

                <div class="splitter">
                  <div class="split left"></div>
                  <div class="split-text">SKRÁÐU ÞIG INN MEÐ:</div>
                  <div class="split right"></div>
                </div>
                <button style="border-radius:5px;" type="button" class="btn btn-opacity-island" v-on:click.prevent="island()">
                  <img src="../assets/island_is_RGB_Hvitt@2x.png" style="width: 150px" alt="Ísland.is" />
                </button>
                <button v-if="googleEnabled" style="border-radius:5px;" type="button" class="btn btn-opacity-google" v-on:click.prevent="google()">
                  <img src="../assets/btn_google_light_normal_ios.svg" rel="stylesheet" style="float:left;" />
                  <span class="googleClass">Google</span>
                </button>
                <button v-if="o365Enabled" style="border-radius:5px;" type="button" class="btn btn-opacity-office" v-on:click.prevent="o365()">
                  <img src="../assets/office.svg" alt="Office" />
                </button>
                <button style="border-radius:5px;" type="button" class="btn btn-opacity btn-pw" v-on:click.prevent="pw()">Lykilorð</button>

                <input
                  type="text"
                  v-if="showPassword"
                  class="form-control"
                  id="username"
                  name="username"
                  placeholder="Kennitala"
                  v-model="username"
                  v-validate="'required'"
                />
                <span class="help-block" v-if="showPassword && errors.has('username:required')">Vinsamlegast sláðu inn kennitölu.</span>
                <input
                  type="password"
                  v-if="showPassword"
                  class="form-control"
                  id="password"
                  name="password"
                  placeholder="Lykilorð"
                  v-model="password"
                  v-validate="'required'"
                />
                <span class="help-block" v-if="showPassword && errors.has('password:required')">Vinsamlegast sláðu inn lykilorð.</span>
                <button type="submit" v-if="showPassword" class="btn btn-login" @click.prevent="validateBeforeSubmit">Innskrá</button>
                <div class="text-center" v-if="showPassword"><a href="/gleymt-lykilord" style="color:#fff">Gleymt lykilorð?</a></div>

                <!-- <div class="splitter" style="margin-top: 30px;">
                  <div class="split left"></div>
                  <div class="split-text">MEÐ VEFPÓST SKÓLA:</div>
                  <div class="split right"></div>
                </div>

                <button style="border-radius:5px;" type="button" class="btn btn-opacity-google" v-on:click.prevent="azure('KVSK')">
                  <img src="../assets/kvennaskolinn.png" style="float:left; width: 30px; height: 30px; position: absolute; left: 10px; top: 7px;" />
                  <div class="schoolClass">Kvennaskólinn</div>
                </button> -->
              </div>
            </div>
          </form>
          <div class="mouse text-center">
            <img v-on:click="scrollTo('#kennslukerfi')" src="../assets/mouse.svg" />
          </div>
        </div>
        <div class="first">
          <div id="kennslukerfi" class="half left darker height750">
            <div class="image-container">
              <img src="../assets/mac.png" />
            </div>
          </div>
          <div class="half right lighter height750">
            <div class="centered keynotes">
              <h2>Kennslukerfi</h2>
              <div class="text-container">
                Kennslukerfi Innu auðveldar kennurum að miðla efni, skjölum, hlekkjum, myndböndum og fl. til sinna nemenda. Með einföldum aðgerðum stýrir
                kennari aðgengi nemenda að sínu efni og getur flokkað það eftir sinum þörfum. Þar getur kennari einnig lagt fyrir verkefni próf fyrir hópa eða
                einstaklinga.
              </div>
            </div>
          </div>
        </div>
        <div class="second">
          <div id="skólakerfi" class="half left height750">
            <div class="centered keynotes">
              <h2>Skólakerfi</h2>
              <div class="text-container">
                <p>Öflugt upplýsingakerfi fyrir fjölbreytta skólastarfsemi.</p>
                <p>
                  INNA heldur utan um alla þætti náms hjá nemendum, s.s. vitnisburð, einkunnir, ástundun, mætingu, námsferil og margt fleira.
                </p>
                <p>
                  Með INNU er auðvelt að leggja á og innheimta skólagjöld eða önnur námsgjöld og senda í bókhaldskerfi viðkomandi skóla, auk þess að stofna
                  kröfur í banka ef þess er þörf.
                </p>
                <p>INNA er samþætt við innritunargátt Menntamálastofnunar fyrir framhaldsskóla.</p>
              </div>
            </div>
          </div>
          <div class="half right height750">
            <div class="image-container">
              <img src="../assets/dashboard.png" />
            </div>
          </div>
        </div>
        <div class="third">
          <div class="half left darker height750">
            <div class="image-container">
              <img src="../assets/iphone.png" />
            </div>
          </div>
          <div id="nemendur" class="half right lighter height750">
            <div class="centered keynotes">
              <h2>Nemendur</h2>
              <div class="text-container">
                Nemendur eru með nútímalegt og þægilegt viðmót sem aðlagar sig að því snjalltæki sem notað er hverju sinni. Nemendur fá mjög góða yfirsýn á sína
                áfanga og frammistöðu. Þeir geta skoðað mætingu, námsferla, skilað verkefnum og séð einkunnir um leið og hún er skráð.
              </div>
            </div>
          </div>
        </div>
        <div class="fourth">
          <div id="inna" class="whole">
            <div class="centered keynotes">
              <h2>Lykileiningar INNU</h2>
              <div class="text-container">
                INNA er byggð upp af nokkrum kjarnaeiningum sem vinna sem ein heild til að veita skólum og nemendum framúrskarandi lausn í tengslum við nám,
                skólarekstur og margt fleira.
              </div>
            </div>
          </div>
        </div>
        <div class="fifth">
          <div class="one-third left">
            <div class="image-container">
              <img src="../assets/tablet.png" />
            </div>
          </div>
          <div class="two-thirds height750">
            <div class="double-row">
              <div class="half left">
                <div class="keypoint">
                  <div class="one-fifth left">
                    <div class="circle-image">
                      <img src="../assets/settings.svg" class="centered" />
                    </div>
                  </div>
                  <div class="four-fifths right">
                    <div class="text-container">
                      <h5>Umsóknarkerfi</h5>
                      <div>
                        INNA er með umfangsmikið umsóknarkerfi sem getur haldið utan um nám sem þarf að sækja sérstaklega um eða greiða sérstaklega fyrir, dæmi
                        eru kvöldnám, fjarnám eða sértækar námsbrautir. Einfalt að nota og tengist greiðslusíðum, Innu og bókahaldskerfi viðkomandi skóla.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="half right">
                <div class="keypoint">
                  <div class="one-fifth left">
                    <div class="circle-image">
                      <img src="../assets/spread.svg" class="centered" />
                    </div>
                  </div>
                  <div class="four-fifths right">
                    <div class="text-container">
                      <h5>Skírteini og útskriftir</h5>
                      <div>
                        INNA gefur skólum kost á því að sérsníða skírteini og útskriftir að sínum hefðum og venjum. Auk þess annast INNA skil allra skírteina og
                        námsferla til upplýsingagáttarinnar island.is en þar geta nemendur sótt skírteini og námsferla eftir að þeir hafa útskrifast úr
                        skólanum.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="double-row">
              <div class="half left">
                <div class="keypoint">
                  <div class="one-fifth left">
                    <div class="circle-image">
                      <img src="../assets/display.svg" class="centered" />
                    </div>
                  </div>
                  <div class="four-fifths right">
                    <div class="text-container">
                      <h5>Aðgengi og öryggi</h5>
                      <div>
                        INNA er vefkerfi og því aðgengilegt hvar og hvenær sem er. INNA er óháð tæknibúnaði og er því jafnt fyrir tölvur og spjaldtölvur, einnig
                        eru helstu aðgerðir aðgengilegar í snjallsíma og allar nýjustu tegundir af vöfrum eru studdir. INNA er hýst í öruggu og vottuðu umhverfi
                        hjá Advania.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="half right">
                <div class="keypoint">
                  <div class="one-fifth left">
                    <div class="circle-image">
                      <img src="../assets/accelerator.svg" class="centered" />
                    </div>
                  </div>
                  <div class="four-fifths right">
                    <div class="text-container">
                      <h5>Kennslukerfi</h5>
                      <div>
                        INNA er með mjög öflugt og sveigjanlegt kennslukerfi sem kennarar geta sniðið að sinni kennslu. Einfalt viðmót til að setja inn og
                        flokka ítarefni (glærur,wordskjöl, myndbönd eða annað), senda nemendum skilaboð, minna á skil á verkefnum og fleira. Verkefna- og
                        prófakerfið er einnig sveigjanlegt og getur kennari lagt verkefni fyrir alla nemendur, staka nemendur eða í smærri hópum.
                        Einkunnaskráning í kennslukerfi er tengd námsferli nemanda.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="double-row">
              <div class="half left">
                <div class="keypoint">
                  <div class="one-fifth left">
                    <div class="circle-image">
                      <img src="../assets/sheet.svg" class="centered" />
                    </div>
                  </div>
                  <div class="four-fifths right">
                    <div class="text-container">
                      <h5>Kennslukannanir</h5>
                      <div>
                        INNA gefur skólum kost á því að hanna sínar eigin kennslukannanir eða aðrar kannanir sem þeir vilja gera hjá öllum nemendum eða í
                        ákveðnum greinum eða önnum. INNA vinnur sjálfvirkt úr niðurstöðum og eru þær aðgengilegar í INNU þegar skólinn hefur opnað fyrir skoðun
                        á þeim. Öflugt tól í nútíma skólarekstri.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="half right">
              <div class="keypoint">
                <div class="one-fifth left">
                  <div class="circle-image">
                    <img src="../assets/heart.svg" class="centered">
                  </div>
                </div>
                <div class="four-fifths right">
                  <div class="text-container">
                    <h5>Heilsueflandi framhaldsskóli</h5>
                    <div>
                      INNA er þáttakandi í verkefninu Heilsueflandi framhaldsskóli og styður kerfið við þá starfsemi í skólunum, með greiðslu- og inneignarkerfi
                      sem nemendur geta notað til að greiða fyrir mat í mötuneytum skólanna sem hafa fengið vottun hjá Landlækni.
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <img src="../assets/infomentor-logo-white.png" />
      <div>
        Suðurlandsbraut 32
      </div>
      <div>
        108 Reykjavík
      </div>
      <!-- <div>
      Sími 440 9000
    </div> -->
    </footer>
  </div>
</template>

<script>
/* global alert: false */

import config from '../services/config'
import auth from '../services/auth'
import router from '../router'

export default {
  name: 'landing',
  data() {
    return {
      // Hidden until the backend says the method is on (INS-35, INS-37)
      o365Enabled: false,
      googleEnabled: false,
      username: '',
      password: '',
      formSubmitted: false,
      errorList: [],
      showPassword: false,
      statusList: [],
      errorText: [],
      warningText: [],
      infoText: []
    }
  },
  methods: {
    scrollTo: function(tag) {
      this.$scrollTo(tag, 1000)
    },
    island() {
      window.location = '/auth/island'
    },
    iskey() {
      window.location = '/auth/island?legacy=true'
    },
    google() {
      window.location = '/auth/google'
    },
    o365() {
      window.location = '/auth/o365'
    },
    azure(s) {
      window.location = `/auth/azure?s=${s}`
    },
    pw() {
      this.showPassword = !this.showPassword
    },
    validateBeforeSubmit() {
      // Validate All returns a promise and provides the validation result.
      this.$validator.validateAll().then(success => {
        this.errorList = []

        if (!success) {
          // handle error
          return
        }

        var credentials = {
          username: this.username,
          password: this.password
        }

        auth.logout()

        this.$http.post(config.LOGIN_URL, credentials).then(
          response => {
            auth.login(response.data.token)
            router.push('adgangur')
          },
          err => {
            if (err.status === 401 && err.data.message) {
              this.$root.loginError = [err.data.message]
              router.push('innskraning?error=login_error')
              // this.errorList = [err.data.message]
            } else if (err.status === 401 && err.data.detail) {
              this.$root.loginError = [err.data.detail]
              router.push('innskraning?error=login_error')
              // this.errorList = [err.data.message]
            } else {
              alert('Óvænt villa kom upp. Vinsamlegast reyndu aftur.')
            }
          }
        )
      })
    },
    loadStatus() {
      this.$http.get(config.STATUS_LIST).then(
        response => {
          this.statusList = response.data
        },
        () => {
          this.statusList = []
        }
      )
    },
    loadErrorText() {
      this.$http.get(config.ERROR_TEXT).then(
        response => {
          this.errorText = response.data
        },
        () => {
          this.errorText = []
        }
      )
    },
    loadWarningText() {
      this.$http.get(config.WARNING_TEXT).then(
        response => {
          this.warningText = response.data
        },
        () => {
          this.warningText = []
        }
      )
    },
    loadInfoText() {
      this.$http.get(config.INFO_TEXT).then(
        response => {
          this.infoText = response.data
        },
        () => {
          this.infoText = []
        }
      )
    },
    loadLoginOptions() {
      this.$http.get(config.LOGIN_OPTIONS).then(
        response => {
          this.o365Enabled = response.data.o365 === true
          this.googleEnabled = response.data.google === true
        },
        () => {
          this.o365Enabled = false
          this.googleEnabled = false
        }
      )
    }
  },
  created() {
    this.loadLoginOptions()
    this.loadStatus()
    this.loadErrorText()
    this.loadWarningText()
    this.loadInfoText()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mobile {
  .main {
    background: linear-gradient(rgba(32, 32, 32, 0.9), rgba(32, 32, 32, 0.9)), url(../assets/banner.jpg) no-repeat 0 0;
    background-position: -190px 0px;
    min-height: 700px;
  }
  .banner-error {
    min-height: 20px;
    background-color: #b33a3a;
    color: #fff;
    margin: auto auto 10px auto;
    margin-top: 10px;
    width: 80%;
    padding: 2px;
    .bannerText {
      text-align: center;
      margin: 1%;
    }
  }
  .banner-warning {
    background-color: #fac012;
    margin: auto auto 10px auto;
    margin-top: 10px;
    width: 80%;
    padding: 2px;
    .bannerText {
      text-align: center;
      margin: 1%;
    }
  }
  .banner-info {
    background-color: #d9d9d9;
    margin: auto auto 10px auto;
    margin-top: 10px;
    width: 80%;
    padding: 2px;
    .bannerText {
      text-align: center;
      margin: 1%;
    }
  }

  .inna-logo img {
    margin-top: 40px;
  }

  .login {
    margin-top: 20px;
    // margin-top: 100px; IES Setja inn þegar banner er tekinn út
  }

  .login > * {
    margin: auto auto 10px auto;
  }
}

.googleClass {
  color: #000000;
  font-family: 'Roboto', sans-serif;
  padding-left: 24px;
  font-size: 20px;
  padding-right: 24px;
  vertical-align: middle;
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.schoolClass {
  color: #000000;
  font-weight: 500;
  font-size: 18px;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}

.desktop .main {
  background: linear-gradient(rgba(32, 32, 32, 0.9), rgba(32, 32, 32, 0.9)), url(../assets/banner.jpg) no-repeat 0 0;
  background-size: 100%;
  min-height: 567px;
}

.top-row {
  padding-bottom: 15px;
}

.desktop .inna-logo {
  display: inline;
}

.desktop .inna-logo img {
  margin: 2.5% auto auto 10%;
}

.anchors {
  margin: 3.5% 10% auto auto;
}

.anchors div {
  display: inline-block;
  text-transform: uppercase;
  font-size: 15px;
  color: #ffffff;
  margin: auto 0 auto 40px;
  cursor: pointer;
}

.anchors div:hover {
  // padding-bottom: 15px;
  border-bottom: 2px solid #ffffff;
}

.slogan-and-login > div {
  display: inline-block;
}

.desktop .banner-error {
  float: right;
  background-color: #b33a3a;
  color: #fff;
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
  margin-top: 10px;
  .bannerText {
    text-align: center;
    margin: 1%;
  }
}
.desktop .banner-warning {
  float: right;
  background-color: #fac012;
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
  margin-top: 10px;
  .bannerText {
    text-align: center;
    margin: 1%;
  }
}
.desktop .banner-info {
  float: right;
  background-color: #d9d9d9;
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
  margin-top: 10px;
  .bannerText {
    text-align: center;
    margin: 1%;
  }
}

.slogan {
  margin: 10% auto 8% 10%;
  font-size: 3vw;
  font-weight: bold;
  text-transform: uppercase;
  color: #ffffff;
  max-width: 16%;

  border-top: 5px solid #ffffff;
  border-bottom: 5px solid #ffffff;
}

.desktop .login {
  float: right;
  margin: 9% 10% auto auto;
}

.login > * {
  margin-bottom: 10px;
  width: 18em;
  height: 3.2em; //3 en breytt útaf google
  display: block;
}

.login input:hover::-webkit-input-placeholder {
  padding-left: 15px;
  -webkit-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.login input:hover:-moz-placeholder {
  padding-left: 15px;
  -moz-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.login input:hover:-ms-input-placeholder {
  padding-left: 15px;
  -ms-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.login input:focus::-webkit-input-placeholder {
  color: #454545;
  -webkit-transition: color 350ms linear;
  transition: color 350ms linear;

  padding-left: 15px;
  -webkit-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.login input:focus:-moz-placeholder {
  color: #454545;
  -moz-transition: color 350ms linear;
  transition: color 350ms linear;

  padding-left: 15px;
  -moz-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.login input:focus:-ms-input-placeholder {
  color: #454545;
  -ms-transition: color 350ms linear;
  transition: color 350ms linear;

  padding-left: 15px;
  -ms-transition: padding-left 350ms linear;
  transition: padding-left 350ms linear;
}

.splitter {
  margin: 0px auto 0px auto;
}

.splitter > div {
  display: inline-block;
  color: #ffffff;
  text-align: center;
}

.splitter > .split {
  z-index: 50;
  width: 6%;
  top: 10px;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.right {
  float: right;
}

.left {
  float: left;
}

.splitter > .split-text {
  letter-spacing: 2.77px;
  font-weight: bold;
  margin-left: 15px;
}

.mouse {
  width: 100%;
  display: inline-block;
}

.mouse img {
  margin-bottom: 2%;
  cursor: pointer;
}

.half {
  width: 50%;
  display: inline-block;
}

.darker {
  background-color: #efefef;
}

.lighter {
  background-color: #fafafa;
}

.image-container {
  text-align: center;
}

.image-container img {
  max-width: 100%;
  margin-top: 2%;
}

.centered {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.keynotes {
  width: 65%;
}

.keynotes h2 {
  font-size: 30px;
  color: #303030;
  font-weight: bold;
}

.keynotes .text-container {
  font-size: 18px;
  color: #454545;
  line-height: 30px;
}

.second .image-container {
  margin-top: 12%;
}

.whole {
  width: 100%;
  float: left;
  height: 400px;
}

.fourth .centered {
  width: 50%;
}

.fourth .centered h2 {
  font-size: 42px;
  font-weight: lighter;
}

.fourth .centered .text-container {
  margin-top: 30px;
  font-size: 24px;
}

.fourth .centered * {
  text-align: center;
}

.height750 {
  height: 750px;
}

.one-third {
  width: calc(100% / 3);
  display: inline-block;
}

.two-thirds {
  width: calc(200% / 3);
  display: inline-block;
}

.one-fifth {
  width: 20%;
  display: inline-block;
}

.four-fifths {
  width: 80%;
  display: inline-block;
}

.fifth .image-container img {
  float: left;
}

.circle-image {
  border: solid 2px #dedede;
  border-radius: 50%;
  height: calc(55px + 0.8vw);
  width: calc(55px + 0.8vw);
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(0%);
}

.keypoint h5 {
  font-weight: bold;
}

.keypoint .text-container {
  margin-top: 25px;
  width: 90%;
}

.double-row {
  overflow: hidden;
}

.double-row > div {
  float: left;
  padding-bottom: 100%;
  margin-bottom: -100%;
}

.btn-pw {
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
}

.googleFont {
  font-family: 'Roboto', sans-serif;
}

footer {
  clear: both;
  background-color: #404040;
  padding: 62px 0;
  color: #fff;
  text-align: center;
  div,
  img {
    display: inline-block;
    padding-right: 34px;
  }
  div:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 18px;
    background-color: #fff;
    margin-left: -17px;
  }
}
@media (max-width: 991px) {
  footer {
    margin-top: -10px;
  }
}
@media (max-width: 599px) {
  footer {
    text-align: left;
    margin-top: -10px;
    padding: 15px 10px 20px 25px;
    img {
      margin-bottom: 15px;
    }
    div {
      display: block;
      padding-top: 5px;
    }
    div:before {
      width: 0px;
    }
  }
}
</style>
